import type { Pixel } from '@/data';
import {
  Staff, StaffType,
} from '@/data';
import { LineName } from './analysis-formats';
import type { StaffFormat } from './UnitParser';

export default class StaffParser extends Staff {
  static parseFormat(formats: StaffFormat[], canvasHeight: Pixel): Staff[] {
    const lines = [new Staff(
      0,
      0 as Pixel,
      canvasHeight as Pixel,
      LineName.all,
      StaffType.bar,
    )];

    const staves = formats.map((format, index) => new Staff(
      index + 1,
      format.top as Pixel,
      format.bottom as Pixel,
      (index + 1).toString(),
    ));

    return [...lines, ...staves];
  }
}
